const YesOrNoEnum=[
    {value:'si',label:'Sí'},
    {value:'no',label:'No'},

  ]

  export default YesOrNoEnum;